// PriceModal.jsx – ungefährer Preis
import React, { useState } from 'react';
import { calcPrice, packLine, fmt, LIEFERKOSTEN, RETOUCH_PRICE } from '../utils/pricing';
import { CopiesInput } from './CopiesInput';
import './Modal.css';

// Wiederverwendete Stile (als JavaScript-Objekte statt CSS-Klassen).
const BOX = { background: '#f8f8f8', borderRadius: 10, padding: '16px 20px', marginBottom: 16 };
const HEAD = { fontSize: 13, fontWeight: 700, color: '#888', marginBottom: 10, textTransform: 'uppercase', letterSpacing: 1 };
const ROW = { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, marginBottom: 4 };
const NOTE = { color: '#888', fontSize: 12, fontStyle: 'italic' };

// persons = Anzahl Personen, retouchCount = Anzahl Bilder mit Bildbearbeitungs-Wunsch.
export function PriceModal({ persons, retouchCount = 0, onClose }) {
  const n = persons;
  // qty = gewählte Anzahl Exemplare; der Preis wird bei jeder Änderung neu berechnet (pricing.js).
  const [qty, setQty] = useState(1);
  const p = calcPrice({ persons: n, copies: qty, retouchCount });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ padding: '32px 28px', maxWidth: 460 }}>
        <h2 style={{ marginBottom: 6, fontSize: 20 }}>Ungefährer Preis</h2>
        <p style={{ color: '#888', fontSize: 13, marginBottom: 24 }}>Für {n} {n === 1 ? 'Person' : 'Personen'} im Stammbaum</p>

        {/* Anzahl Exemplare */}
        <div style={BOX}>
          <div style={HEAD}>Anzahl Exemplare</div>
          <CopiesInput value={qty} onChange={setQty} />
        </div>

        {/* Preis */}
        <div style={{ ...BOX, marginBottom: 20 }}>
          <div style={HEAD}>Preis</div>
          <div style={ROW}>
            <span style={{ color: '#333' }}>{packLine(qty, p)}</span>
            <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{fmt(p.druck)}</span>
          </div>
          {retouchCount > 0 && (
            <div style={ROW}>
              <span style={{ color: '#333' }}>{retouchCount} {retouchCount === 1 ? 'Bild' : 'Bilder'} von Hand bearbeiten × {RETOUCH_PRICE} CHF</span>
              <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{fmt(p.retouch)}</span>
            </div>
          )}
          <div style={ROW}>
            <span style={{ color: '#333' }}>Lieferkosten</span>
            <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{fmt(LIEFERKOSTEN)}</span>
          </div>
          <div style={{ borderTop: '1px solid #ddd', marginTop: 8, paddingTop: 10, display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontWeight: 700 }}>Total</span>
            <span style={{ fontWeight: 700, color: '#1540dc' }}>{fmt(p.total)}</span>
          </div>
          <div style={{ ...NOTE, marginTop: 8 }}>
            Ein 12er-Pack reicht für bis zu 12 Personen, ein 24er-Pack für 24, ein 36er-Pack für 36. Bei mehr Personen wird die günstigste Kombination gewählt.
          </div>
        </div>

        <p style={{ color: '#aaa', fontSize: 12, marginBottom: 20, lineHeight: 1.5 }}>
          * Preise sind ungefähre Richtwerte. Der definitive Preis wird nach Auftragserteilung kommuniziert.
        </p>

        <button className="btn btn--primary" onClick={onClose} style={{ width: '100%', padding: '12px 0', fontSize: 15, borderRadius: 8 }}>
          Schliessen
        </button>
      </div>
    </div>
  );
}
